module.exports = __webpack_public_path__ + "static/hannah-c9bbe32f32a1883f96c48aa75f54332a.jpg";